import { jsx as _jsx } from "react/jsx-runtime";
import MapComponent from "@/mapComponent";
import { createRoot } from 'react-dom/client';
// Define a React component
function App() {
    return (_jsx(MapComponent, {}));
}
if (document.getElementById('findApp')) {
    // Render the React component to the root element in the HTML
    createRoot(document.getElementById('findApp')).render(_jsx(App, {}));
}
